import { Box } from "@mui/material";
import React from "react";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ListAltIcon from "@mui/icons-material/ListAlt";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { useGetDashboardStatsHook } from "../hooks/dashboard.hook";
import { StatTileComponent } from "./stat-tile.component";
import { MonthlyReservationsChartComponent } from "./monthly-reservations-chart.component";
import { HorizontalBarListComponent } from "./horizontal-bar-list.component";
import { RecentUsersComponent } from "./recent-users.component";
import { RecentReservationsComponent } from "./recent-reservations.component";
import { getReservationStatus } from "../../../shared/elements/customTable.component";
import { ListingCategoryType } from "../dto/dashboard.dto";

const CATEGORY_COLORS: Record<ListingCategoryType, string> = {
  activity: "#2a78d6",
  restaurant: "#1baf7a",
  accomodation: "#eda100",
  competition: "#008300",
  event: "#4a3aa7",
};

export const DashboardOverviewComponent: React.FC = () => {
  const { data, isLoading, error } = useGetDashboardStatsHook();

  if (isLoading) {
    return (
      <Box p={2} textAlign="center" color="#999" fontSize="0.85rem">
        Chargement du tableau de bord...
      </Box>
    );
  }

  if (error || !data) {
    return (
      <Box p={2} textAlign="center" color="#c0392b" fontSize="0.85rem">
        Erreur lors du chargement du tableau de bord.
      </Box>
    );
  }

  const statusData = data.reservationsByStatus.map((item) => {
    const status = getReservationStatus(item.status);
    return {
      key: item.status,
      label: status.label,
      value: item.count,
      color: status.color,
    };
  });

  const categoryData = data.listingsByCategory.map((item) => ({
    key: item.type,
    label: item.label,
    value: item.count,
    color: CATEGORY_COLORS[item.type],
  }));

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* KPI row */}
      <Box display="flex" flexWrap="wrap" gap={2}>
        <StatTileComponent
          label="Utilisateurs"
          value={data.totals.users}
          icon={<PeopleAltIcon fontSize="small" />}
        />
        <StatTileComponent
          label="Annonceurs"
          value={data.totals.proAccounts}
          icon={<StorefrontIcon fontSize="small" />}
        />
        <StatTileComponent
          label="Annonces"
          value={data.totals.listings}
          icon={<ListAltIcon fontSize="small" />}
        />
        <StatTileComponent
          label="Réservations"
          value={data.totals.reservations}
          icon={<EventAvailableIcon fontSize="small" />}
        />
      </Box>

      {/* Charts row */}
      <Box display="flex" flexWrap="wrap" gap={2}>
        <MonthlyReservationsChartComponent data={data.reservationsByMonth} />
        <HorizontalBarListComponent
          title="Annonces par catégorie"
          data={categoryData}
        />
        <HorizontalBarListComponent
          title="Réservations par statut"
          data={statusData}
        />
      </Box>

      {/* Recent activity row */}
      <Box display="flex" flexWrap="wrap" gap={2}>
        <RecentUsersComponent data={data.recentUsers} />
        <RecentReservationsComponent data={data.recentReservations} />
      </Box>
    </Box>
  );
};
